import { render, staticRenderFns } from "./ProgramDetail.vue?vue&type=template&id=98fc2468&scoped=true&"
import script from "./ProgramDetail.vue?vue&type=script&lang=js&"
export * from "./ProgramDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetail.vue?vue&type=style&index=0&id=98fc2468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fc2468",
  null
  
)

export default component.exports